import Button from "@mui/material/Button"
import Box from '@mui/material/Box';
import { validate, hasErrors, validateAll, required, } from '../components/Validators';
import { useContext, useEffect, useState } from "react";
import useApi, { isProd } from "../api";
import { consultarCuenta, login } from "../api/cuenta";
import TextField from "../components/TextField";
import { IconButton, InputAdornment, LinearProgress, Paper, Typography } from "@mui/material";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { AppContext } from "../App";
import { useNavigate } from "react-router-dom/dist";
import { img } from "../components/Utils";
import metadataJson from '../metadata.json';

const fieldsValidators = {
    'username': [required],
    'password': [required],
}

const defaultErrors = {
    username: '',
    password: '',
}

const defaultData = {
    username: '',
    password: '',
    showPassword: false,
}

export default function Login() {

    const appContext = useContext(AppContext);
    const navigate = useNavigate();

    const { actualizaCuenta, notificarError, wipeAllData } = appContext;

    const [errors, setErrors] = useState(defaultErrors);
    const [data, setData] = useState(defaultData);

    const [{ data: loginData, loading: loadingLogin, error: loginError }, loginApi] = useApi(null, { defaultError: false });
    const [{ data: logoutData, loading: loadingLogout }, logoutApi] = useApi();
    const [{ data: cuentaData, loading: loadingCuenta }, cuentaApi] = useApi();

    useEffect(() => {
        if (loginData) {
            cuentaApi(consultarCuenta());
        }
    }, [loginData]);

    useEffect(() => {
        if (loginError) {
            if (loginError.message === "Network Error" || (loginError.response && loginError.response.status === 503)) {
                notificarError("Servicio no disponible, intente nuevamente");
            } else {
                setErrors({
                    username: loginError.response.data.message
                })
            }
        }
    }, [loginError]);

    //Se cuando se hace el logout...
    useEffect(() => {
        if (logoutData) {
            wipeAllData();
            setData(defaultData);
            setErrors(defaultErrors);
            //resetDataApiLogin();
            // history.replace("/");
        }
    }, [logoutData]);

    useEffect(() => {
        if (cuentaData) {
            // const cuentaPermisos = cuentaData.permisos.filter(p => ["PERM_ADMIN_CLIENTES"].includes(p));
            // //Revisamos que a cuenta tenga el permiso...
            // if (cuentaPermisos.length > 0) {
            //     actualizaCuenta({
            //         id: loginData.id,
            //         loggedIn: true
            //     });
            //     if (isProd) {
            //         navigate("/", { replace: true }); //Garantizamos ir al home
            //     }
            // } else {
            //     notificarError("No tiene permisos para acceder a esta aplicación");
            //     logoutApi(logout());
            // }
            //Siempre obtenemos el primer grupo de operadores...

            actualizaCuenta({
                ...cuentaData,
                loaded: true,
                loggedIn: true,
            });
            if (isProd) {
                navigate("/", { replace: true }); //Garantizamos ir al home
            }
        }
    }, [cuentaData]);

    const handleChangeValue = name => event => {
        const value = event.target.value;
        const error = validate(value, fieldsValidators[name]);

        setData({
            ...data,
            [name]: value,
        })
        setErrors({
            ...errors,
            [name]: error,
        })
    }

    const handleOnBlur = name => event => {
        const value = event.target.value;
        const error = validate(value, fieldsValidators[name]);
        setErrors({
            ...errors,
            [name]: error,
        })
    }

    const handleKeyPress = event => {
        if (event.key === "Enter") {
            doLogin();
        }
    };

    const doLogin = event => {
        const errors = validateAll(data, fieldsValidators);
        const isValid = !hasErrors(errors)

        if (isValid) {
            setErrors(defaultErrors);
            loginApi(login(data.username, data.password));
        }
    }

    const handleClickShowPassword = () => {
        setData({ ...data, showPassword: !data.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Box component="main" sx={{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
            <Paper sx={{ borderRadius: 4, position: 'relative', }}>
                <Box
                    sx={{
                        //marginTop: 8,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: { xs: null, sm: 400 }, padding: 4 }}>
                        <Box sx={{ mb: 1, textAlign: 'center' }}>
                            <img src={img("/images/pase-logo.jpg")} alt="logo-login" height={60} />
                            <Typography color="secondary" sx={{ mt: 1, fontWeight: 450 }}>Telepeaje Estacionamientos</Typography>
                            <Typography color="secondary">Consola de operación</Typography>
                        </Box>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Usuario"
                            field="username"
                            autoFocus
                            disabled={(loadingLogin || loadingLogout || loadingCuenta)}
                            value={data.username}
                            onKeyPress={handleKeyPress}
                            onChange={(handleChangeValue('username'))}
                            onBlur={(handleOnBlur('username'))}
                            errors={errors} />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Contraseña"
                            field="password"
                            type="password"
                            disabled={(loadingLogin || loadingLogout || loadingCuenta)}
                            value={data.password}
                            onKeyPress={handleKeyPress}
                            onChange={(handleChangeValue('password'))}
                            onBlur={(handleOnBlur('password'))}
                            errors={errors}
                            inputProps={{
                                type: data.showPassword ? 'text' : 'password'
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="cambiar visibilidad del password"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}>
                                            {data.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }} />
                        <Button
                            variant="contained"
                            sx={{ mt: 3, mb: 2, width: 120 }}
                            disabled={(loadingLogin || loadingLogout || loadingCuenta)}
                            onClick={doLogin}>
                            Acceder
                        </Button>
                        {(loadingLogin || loadingLogout || loadingCuenta) &&
                            <LinearProgress />
                        }
                    </Box>
                    <Box sx={{ display: { xs: 'none', sm: 'none', md: 'contents' } }}>
                        <img src={img("/images/estacionamiento.jpg")} style={{ borderRadius: '0px 16px 16px 0px' }} alt="logo-login" width={400} height={500} />
                    </Box>
                </Box>
                <Typography variant="caption" component={"div"} style={{ position: 'absolute', bottom: 8, left: 16 }}>
                    V {metadataJson.version}B{metadataJson.build}
                </Typography>
            </Paper>
        </Box>
    )
}
